// APG combobox list navigation, shared by the header search box (ui.js) and the
// /search page box (search.js). Focus stays in the input while the arrow keys
// move a highlighted [role="option"] inside `popup`, exposed to screen readers
// through aria-activedescendant. Options are styled by .menu__item[aria-selected].
export function createCombobox(input, popup, idPrefix) {
  function options() {
    return Array.from(popup.querySelectorAll('[role="option"]'));
  }

  function active() {
    var id = input.getAttribute("aria-activedescendant");
    return id ? document.getElementById(id) : null;
  }

  function setActive(option) {
    var current = active();
    if (current) current.removeAttribute("aria-selected");

    if (option) {
      option.setAttribute("aria-selected", "true");
      input.setAttribute("aria-activedescendant", option.id);
      option.scrollIntoView({ block: "nearest" });
    } else {
      input.removeAttribute("aria-activedescendant");
    }
  }

  // Down from the input highlights the first option; Up from the first option
  // returns to the typed text. Stops at the last option.
  function move(direction) {
    var all = options();
    if (all.length === 0) return;

    var next = all.indexOf(active()) + direction;
    setActive(next < 0 ? null : all[Math.min(next, all.length - 1)]);
  }

  // Call after each render into the popup: the options are new elements, so
  // give them ids and drop the stale highlight.
  function reset() {
    input.removeAttribute("aria-activedescendant");
    options().forEach(function (option, i) {
      option.id = idPrefix + i;
    });
  }

  return { options: options, active: active, setActive: setActive, move: move, reset: reset };
}
